import React from "react";
import SharedProfileReviews from "../../shared/reviews";
import { ProfileBodyProps } from "../../types";

const Reviews = React.memo((props: ProfileBodyProps) => {
  const user = props.user;
  return <SharedProfileReviews userId={user.id} user={props.user} />;
});

Reviews.displayName = "Reviews";

export default Reviews;
